import React from 'react';
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Matchup } from 'src/models';
import PicksDataGrid from './PicksDataGrid';
import ResultsTable from './ResultsTable';

type Props = {
  matchups: Matchup[];
};

const ResultsAccordion = ({ matchups }: Props) => {
  // we only want to show results for matchups that have started
  // otherwise we expose picks to early
  const startedMatchups = matchups.filter((match) => {
    return match.startTime < Date.now();
  });

  return (
    <>
      {startedMatchups.map((match) => (
        <Accordion key={match.gamePk}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant='subtitle1'>
              {`${match.teams.home.abbreviation} vs ${match.teams.away.abbreviation}`}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid item xs={12}>
                <ResultsTable
                  season={match.season}
                  playoffSeriesLetter={match.playoffSeriesLetter}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <PicksDataGrid
                  season={match.season}
                  playoffSeriesLetter={match.playoffSeriesLetter}
                  topSeedTeam={match.teams.home}
                  botSeedTeam={match.teams.away}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default ResultsAccordion;
